import {observable} from 'mobx';
import {nonenumerable} from 'core-decorators';

class GiftsState {
  get DATE_FORMAT() { return 'YYYY/MM/DD'; }

  @observable giftDisplayText = '';

  @observable orderContent = {};

  @nonenumerable
  listeners = [];

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default GiftsState;



// WEBPACK FOOTER //
// ./spa/state/gifts.jsx